<template>
    <v-form ref="form_datos_representante">
        <v-container fluid grid-list-md>
            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-autocomplete label="Tipo Documento *" color="textbox" v-model="objForm.idTipoDocumento"
                        :items="listGeneral.listaTipoDocumento" item-value="idTipoDocumento" item-text="tipoDocumento"
                        :rules="requeridoRegla" outlined dense />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field label="Cédula o Ruc *" color="textbox" v-model="objForm.numDocumento"
                        :rules="parseInt(objForm.idTipoDocumento) == parseInt(parametros.idTipoDocCedula) ? _.concat(requeridoRegla,cedula) : _.concat(requeridoRegla,ruc)"
                        outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-text-field label="Nombres Completos *" color="textbox" v-model="objForm.nombresCompletos"
                        :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objForm.nombresCompletos,300))" outlined
                        dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Teléfono Domicilio *" color="textbox" v-model="objForm.telefono"
                        v-mask="'(##) ### - ####'" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-dialog ref="dialog" v-model="abrirDialogo" :return-value.sync="objForm.fechaNacimiento"
                        persistent width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field color="textbox" v-model="objForm.fechaNacimiento"
                                label="Fecha de Nacimiento *" :rules="requeridoRegla" prepend-inner-icon="event"
                                readonly outlined dense v-on="on" />
                        </template>
                        <v-date-picker color="primary" v-model="objForm.fechaNacimiento" scrollable locale="es">
                            <v-spacer></v-spacer>
                            <v-btn outlined dense rounded color="danger" @click="abrirDialogo = false" v-text="'Salir'">
                            </v-btn>
                            <v-btn rounded dark color="primary" @click="$refs.dialog.save(objForm.fechaNacimiento)"
                                v-text="'Guardar Fecha'"></v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado Civil *" color="textbox" v-model="objForm.idEstadoCivil"
                        :items="listGeneral.listaEstadoCivil" item-value="idEstadoCivil" item-text="estado"
                        :rules="requeridoRegla" @change="onEstadoCivil" outlined dense />
                </v-col>
            </v-row>
            <v-row dense v-if="mostrarFormConyuge">
                <v-col cols="12" sm="12">
                    <span v-html="'Datos del Cónyuge'" class="text-dark"></span>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="objForm.cedulaConyuge" color="textbox" label="Cedula *"
                                :rules="mostrarFormConyuge ? _.concat(requeridoRegla,cedula) : []" outlined dense />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="objForm.nombreConyuge" color="textbox" label="Nombres y Apellidos *"
                                :rules="mostrarFormConyuge ? _.concat(requeridoRegla,soloLetrasRegla(1,objForm.nombresConyuge,300)) : []"
                                outlined dense />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field label="Email *" color="textbox" v-model="objForm.email" :rules="emailRegla" outlined
                        dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Provincia *" color="textbox" v-model="objForm.idProvincia"
                        :items="listGeneral.listaProvinciaRepre" :rules="requeridoRegla" @change="onListarCantones"
                        outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Cantón *" color="textbox" v-model="objForm.idCanton"
                        :items="listGeneral.listaCantonRepre" :rules="requeridoRegla" item-value="idCanton"
                        item-text="canton" :disabled="_.isUndefined(objForm.idProvincia)" outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-text-field label="Dirección *" color="textbox" v-model="objForm.direccion" :rules="max300Regla"
                        outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" class="text-right mt-3 mb-3">
                    <v-btn outlined rounded color="danger" class="mr-1" @click="previous('objDatosRepre',objForm)">Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="next('objDatosRepre',objForm)">Siguiente</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import { mask } from 'vue-the-mask';
    export default {
        name: 'StepperDatoRepresentanteComponent',
        inject:['next','previous'],
        directives:{mask},
        props:{
            cargar:{
                type:Boolean,
                default: false
            },
            objForm:{
                type:Object,
                default:{}
            },
            listGeneral:{
                type:Object,
                default:{}
            },
            parametros:{
                type:Object,
                default:{}
            }
        },
        data: () => ({
            abrirDialogo: false,
            mostrarFormConyuge: false
        }),
        watch:{
            cargar(val){
                if (val && _.size(this.objForm.idTipoDocumento) == 0){
                    var fecha = _.size(_.get(this.objForm,'fechaNacimiento','')) == 0 ? moment().format('YYYY-MM-DD') : this.objForm.fechaNacimiento;
                    this.next('objDatosRepre',{fechaNacimiento:fecha},false);
                    this.onCargaGeneral();
                    
                } 
                
            }
        },
        methods:{
            onCargaGeneral(){
                this.listGeneral.listaTipoDocumento = _.filter(this.listGeneral.listaTipoDocumento,{'visualiza':'true'});
                this.listGeneral.listaEstadoCivil   = _.filter(this.listGeneral.listaEstadoCivil,{'visualiza':'true'});

                this.next('objDatosRepre',{idTipoDocumento:_.toString(this.parametros.idTipoDocCedula)},false);
                
                this.onListarProvincia('L')
                    .then((r) => {
                        if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            return this.onInformacionRepresentante('L');
                    })
                    .then((r) => {
                        if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            return this.onListarCantones('L');
                    })
                    .catch((e) => { 
                        console.info(e);
                    });
            },
            onInformacionRepresentante(event){
                if (!_.isUndefined(event)) {
                    var error = 'E';
                    var o = _.merge({},
                                    {opcion:'LISTAR_REPRESENTANTE_LEGAL',
                                    'idEstado': this.parametros.idEstadoDefault},
                                    _.pick(this.objForm,['idFormulario','idContratante','idPoliza'])
                                    );
        
                    return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/contratante/listar`,o)
                                .then((r) => {
                                    if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                            this.next('objDatosRepre',_.merge({},this.objForm,r.data.data[0]),false);
                                            this.onEstadoCivil();
            
                                        return r;
                                    })
                                    .catch((e) => { 
                                        mensajesAlerta(e,error); 
                                        return e;
                                    });
                }
            },
            onListarProvincia(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var o = {'opcion': 'L','idEstado': this.parametros.idEstadoDefault};

                    this.next('listaProvinciaRepre',[],false);
                    return axios.post(`${BASE_URI}administrador/provincia/listar`,o)
                                .then((r) => {
                                    if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                        this.next('listaProvinciaRepre',r.data.data,false);
                                    
                                    return r;
                                })
                                .catch((e) => { 
                                    mensajesAlerta(e,error); 
                                    return e;
                                });
                }
            },
            onListarCantones(event){
                if(!_.isUndefined(event)){
                    var e = 'E';
                    var o = {
                                'opcion'      : 'L',
                                'idProvincia' : this.objForm.idProvincia,
                                'idEstado'    : this.parametros.idEstadoDefault
                            }
        
                    this.next('listaCantonRepre',[],false);
                    return axios.post(`${BASE_URI}administrador/canton/listar`,o)
                                .then((r) => {
                                    if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                        this.next('listaCantonRepre',r.data.data,false);
                                    
                                    return r;
                                })
                                .catch((e) => { 
                                    mensajesAlerta(e,error); 
                                    return e;
                                });                     
                }
            },            
            onEstadoCivil(){
                var o = _.find(this.listGeneral.listaEstadoCivil, (o) => { return _.toUpper(o.estado) == 'CASADO'});
                this.mostrarFormConyuge = parseInt(o.idEstadoCivil) == parseInt(this.objForm.idEstadoCivil) ? true : false;
            }
        }
    }
</script>